import { ErrorCode as BaseErrorCode } from '@zattoo/playback-sdk';
export const ErrorCode = {
    ...BaseErrorCode,
    PinRequired: 20000,
};
